import { AnyChildDataSource } from "./RemoteChildDataSource";
import { RemoteListChildDataSource } from "./RemoteListChildDataSource";

export function queryParamParentChangeStrategy(
  fieldName: string,
  refName: string
) {
  return function parentChangedStrategy(ds: AnyChildDataSource) {
    if (ds.parent.id) {
      if (ds instanceof RemoteListChildDataSource) {
        ds.addOrReplaceDefaultFilter(refName, ds.parent.id[fieldName]);
      }
      ds.lock.unlock();
    } else {
      ds.lock.lock();
    }
  };
}

export function queryParamDtoStrategy(fieldName: string, refName: string) {
  return function parentChangedStrategy(ds: AnyChildDataSource, dto: any) {
    dto[refName] = ds.parent.id[fieldName];
    return dto;
  };
}

export function pathVariableParentChangeStrategy() {
  return (ds: AnyChildDataSource) => {
    const link = ds.parent.link();

    if (ds.parent.id) {
      ds.url = link + ds.urlSuffix;
      ds.lock.unlock();
    } else {
      ds.lock.lock();
      ds.url = "NO_PARENT_ERROR";
    }
  };
}

export function pathVariableDtoStrategy() {
  return (ds: AnyChildDataSource, dto: any): any => {
    return dto;
  };
}
